import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { MessagePageProps } from './types';

export const StyledMessagePage = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  min-height: ${(props: any) => (props.preview ? 'auto' : '100vh')};
  flex: ${(props: any) => props.flex || 'auto'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: ${(props: MessagePageProps) => props.fontFamily};
  .container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 20px;
    margin: 0;

    h1 {
      margin: auto;
      max-width: 400px;
      display: flex;
      padding: 1em 20px 0 20px;
      margin: 0;
      align-items: center;
      background: ${(props: any) => createGradientOrSolid(props.headerColors)};
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    h2 {
      max-width: 450px;
      margin: 16px 0;
      color: ${(props: MessagePageProps) => props.textColor};
      font-size: ${(props: MessagePageProps) => props.textSize + 'px'};
      font-weight: ${(props: MessagePageProps) => props.textWeight};
    }

    .coinsAnimation {
      position: absolute;
      width: 1024px;
      top: -250px;
    }

    &--ios13 {
      h1 {
        background: none;
        -webkit-background-clip: initial;
        -webkit-text-fill-color: initial;
        color: ${(props: any) => createGradientOrSolid(props.headerColors)};
      }
    }
  }
` as any;
